import { PINNED_ASSET_SLUG } from "@/config/game";
import { useScrollLock } from "@/hooks/useScrollLock";
import { canUseClubImportSelector } from "@/redux/user/userSlice";
import { useTranslation } from "@repo/shared/i18n";
import { useSelector } from "react-redux";

import { BaseEvoPopup } from "./BaseEvoPopup";

interface CompleteSavedEvoPopupProps {
  onClose: () => void;
  onConfirm: () => void;
  warningMessage?: React.ReactNode;
  ctaLabel?: string;
}

export const CompleteSavedEvoPopup = ({
  onClose,
  onConfirm,
  warningMessage,
  ctaLabel,
}: CompleteSavedEvoPopupProps) => {
  const { t } = useTranslation(["evolutions", "common"]);
  useScrollLock(true);
  const canUseClubImport = useSelector(canUseClubImportSelector);

  return (
    <BaseEvoPopup
      posLabel={ctaLabel ?? t("common:confirm")}
      onPositive={onConfirm}
      handleOnClose={onClose}
      title={t("popups.completeSaved.title")}
      imageUrl={
        import.meta.env.VITE_APP_ASSETS_BASE_URL +
        `/${PINNED_ASSET_SLUG}/evolutions-hub/my-evolutions/complete-evo.png`
      }
    >
      <>
        <div className="flex flex-col gap-y-2">
          {warningMessage ? (
            warningMessage
          ) : canUseClubImport ? (
            <p>{t("popups.completeSaved.bodyClubImport")}</p>
          ) : (
            <>
              <p className="font-medium text-foreground-body">
                {t("popups.completeSaved.bodyIntro")}
              </p>
              <ul className="list-disc list-inside flex flex-col gap-y-1">
                <li>{t("popups.completeSaved.bodyChangeState")}</li>
                <li>{t("popups.completeSaved.bodyMovePlayer")}</li>
              </ul>
            </>
          )}
        </div>
      </>
    </BaseEvoPopup>
  );
};
